import { RouteRecordRaw } from 'vue-router';

export default (): Array<RouteRecordRaw> => {
    return [
        {
            path: '/network/vacations',
            name: 'network_vacations',
            component: () => import("./views/vacations.vue"),
            meta: {
                bottomCutFixed: true,
            }
        },
        {
            path: '/network/bookVacation',
            name: 'network_bookVacation',
            component: () => import("./views/bookVacation.vue"),
            meta: {
            }
        },
        {
            path: '/network/parkVacation',
            name: 'network_parkVacation',
            component: () => import("./views/parkVacation.vue"),
            meta: {
            }
        },
    ];
};